import { motion, AnimatePresence } from "motion/react";
import { useEffect } from "react";

interface ToastProps {
  message: string;
  type: "success" | "info" | "warning" | "error";
  onClose: () => void;
}

export default function Toast({ message, type, onClose }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const typeConfig = {
    success: { bg: "#0F3D2E", icon: "✓" },
    info: { bg: "#1B2A5B", icon: "ℹ" },
    warning: { bg: "#7A3E00", icon: "⚠" },
    error: { bg: "#991B1B", icon: "✕" },
  };

  const config = typeConfig[type];

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      className="fixed bottom-28 left-5 right-5 z-[90]"
    >
      <div
        className="rounded-2xl p-4 backdrop-blur-xl flex items-center gap-3"
        style={{
          backgroundColor: `${config.bg}`,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
        }}
      >
        <div
          className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center"
          style={{ fontSize: "16px" }}
        >
          {config.icon}
        </div>
        <p
          className="flex-1 text-white"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          {message}
        </p>
        <button
          onClick={onClose}
          className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center text-white"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L10 10M2 10L10 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
    </motion.div>
  );
}